import { Injectable } from '@angular/core';
import {
  DataModel,
  MetaModel,
  WidgetModel,
} from 'common/models/utility-models/base-model';
import { FormWidgetService } from '../form-widget.service';
import { AssignmentFormDataService } from 'common/services/data-services/admin/assignment/assignment-form.data.service';
import { SystemService } from 'common/services/core-services/system.service';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';
import { AssignmentMetaModel } from 'common/models/page-models/Assignments Model/assignments-form-meta.model';
import { GroupsGridDataService } from 'common/services/data-services/admin/groups/groups-grid-data.service';
import { LocationGridDataService } from 'common/services/data-services/admin/location/location-grid-data.service';
import { TrainersGridDataService } from 'common/services/data-services/admin/trainer/trainers-grid.data.services';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { branchListDataService } from 'common/services/data-services/custom-service/branchList-service';
import { StudentsGridDataService } from 'common/services/data-services/admin/students/students-grid-data.service';
import { CategoryListDataService } from 'common/services/data-services/custom-service/categoryList-services';
import { TypesListDataService } from 'common/services/data-services/custom-service/types-service';
import { zoneListDataService } from 'common/services/data-services/custom-service/zoneList-service';

@Injectable({
  providedIn: 'root',
})
export class AssignmentFormWidgetService extends FormWidgetService<AssignmentModel> {
  constructor(
    protected ds: AssignmentFormDataService,
    private ss: SystemService,
    private groupListService: GroupsGridDataService,
    private location: LocationGridDataService,
    private type: TypesListDataService,
    private category: CategoryListDataService,
    private trainer: TrainersGridDataService,
    private batch: BatchListDataService,
    private branch: branchListDataService,
    private studentService: StudentsGridDataService,
     protected zoneList: zoneListDataService,
  ) {
    super(ds);
  }

  override prepareMetaModel(
    dataModel: AssignmentModel,
    metaModel: AssignmentMetaModel,
    routeData: WidgetModel,
    event: any = null
  ): Promise<AssignmentMetaModel> {
    return new Promise<AssignmentMetaModel>((resolve, reject) => {
      // Set page title based on operation
      if (routeData.transferData.navPageType !== "View Assignment") {
        metaModel.pageTitle = dataModel.id && dataModel.id !== "" ? 'Edit Assignment' : 'Add Assignment';
      } else {
        metaModel.pageTitle = "View Assignment";
        metaModel.properties.start_date.readOnly = true;
        metaModel.properties.start_date.propreadOnly = true;
      }

      // Create array of all API calls
      const apiCalls = [
        this.batch.postData(''),
        this.branch.postData(''),
        this.groupListService.postData(''),
        this.studentService.postData(''),
        this.location.postData(''),
        this.type.postData(''),
        this.category.postData(''),
        this.trainer.postData(''),
        this.zoneList.postData('')
      ];

      // Wait for all API calls to complete
      Promise.all(apiCalls)
        .then(([
          batchData,
          branchData,
          groupData,
          studentData,
          locationData,
          typeData,
          categoryData,
          trainerData,
          zoneData
        ]) => {
          // Set batch options
          console.log(zoneData);
          metaModel.properties['regionIds']=zoneData.details
          metaModel.properties['batch_id'].options = batchData.details;

          // Set branch options
          metaModel.properties['branch_id'].options = branchData.details;

          // Set group options
          if (dataModel.id && dataModel.id !== "") {
            metaModel.properties['group_id'].options = groupData.details.filter(
              (group) => group.batch_id === dataModel.batch_id
            );
          }
          routeData.transferData.groups = groupData.details;

          // Set student options
          if (dataModel.id && dataModel.id !== "") {
            metaModel.properties['student_ids'].options = studentData.details.filter(
              (student) => student.batch_id === dataModel.batch_id && 
              (student.status === 1 || student.status === 3)
            );
          }
          routeData.transferData.students = studentData.details;

          // Set location options
          metaModel.properties['location'].options = locationData.details;

          // Set type options
          metaModel.properties['type_id'].options = typeData.details;

          // Set category options
          if (dataModel.id && dataModel.id !== "") {
            const filteredCategories = categoryData.details.filter(
              (category) => category.typeId === dataModel.type_id
            );
            metaModel.properties['category'].options = filteredCategories;
          } else {
            metaModel.properties['category'].options = categoryData.details;
          }
          routeData.transferData.category = categoryData.details;

          // Set trainer options
          if (dataModel.id && dataModel.id !== "") {
            const selectedCategory = routeData.transferData.category.filter(
              (category) => category.id === dataModel.category
            );
            
            if (selectedCategory.length > 0) {
              const filteredTrainers = trainerData.details.filter((trainer) =>
                trainer.category_name.split(",").includes(selectedCategory[0].category_name)
              );
              metaModel.properties['trainer'].options = filteredTrainers;
            }
          }
          routeData.transferData.trainer = trainerData.details;

          // Handle view mode
          if (routeData.transferData?.PageType === 'View') {
            metaModel.properties.readonlyInput.forEach((item) => {
              item.readOnly = true;
            });
            metaModel.properties.save.isHideButton = true;
          } else {
            metaModel.properties.save.isHideButton = false;
          }

          // Resolve with the populated metaModel
          resolve(metaModel);
        })
        .catch((error) => {
          console.error('Error loading data for assignment form:', error);
          // Even if some API calls fail, resolve with what we have
          // You might want to show an error message to the user here
          this.ss.showError('Error loading form data. Please try again.');
          reject(error);
        });
    });
  }

  deleteUploadedFile(body, url) {
    this.ds.postLoginData(body, url).then((response) => {
      if (response.status === 'Success') {
        this.ss.showSuccess(response.msg);
      }
    });
  }

  getMetaModel(): MetaModel {
    const meta = new AssignmentMetaModel();
    return meta.getMetaModel();
  }
}